var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.componentStyle.comp,
    _vm._g(
      _vm._b(
        {
          tag: "component",
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        "component",
        { ..._vm.componentStyle.props },
        false
      ),
      _vm.componentStyle.on
    ),
    [
      _vm.selectionChips.length && _vm.relative
        ? _c(
            "v-container",
            { staticClass: "px-5 pt-5 pb-0" },
            [
              _c(
                "v-card-subtitle",
                { staticClass: "py-0", staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-chip-group",
                    { attrs: { column: "" } },
                    _vm._l(_vm.selectionChips, function (chip) {
                      return _c(
                        "v-chip",
                        {
                          key: chip.name,
                          staticClass: "soli-grey mr-1 animate__animated",
                          class: _vm.chipAnimation ?? null,
                          attrs: {
                            outlined: "",
                            close: "",
                            elevated: "",
                            color: "accent shadow-blue",
                            ripple: false,
                          },
                          on: {
                            "click:close": function ($event) {
                              return _vm.$emit("findChip", chip)
                            },
                            click: function ($event) {
                              return _vm.$emit("findChip", chip)
                            },
                          },
                        },
                        [_vm._v(_vm._s(chip.selection.data()))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        { class: [_vm.relative ? "v-card--flat soli-round" : "v-card--tile"] },
        [
          _vm.lessonDetails || _vm.imgSrc
            ? _c(
                "v-img",
                {
                  staticClass: "soli-text-shadow",
                  class: [
                    !_vm.subtitle ? "align-end" : null,
                    !_vm.imgSrc ? "soli-blue" : null,
                  ],
                  attrs: {
                    src: _vm.imgSrc,
                    height: _vm.subtitle ? "212px" : "200px",
                    gradient: _vm.imgSrc
                      ? "to top right, rgba(76, 135, 201, 1), rgba(123, 177, 224, 0.1)"
                      : null,
                    position: _vm.imgPosition,
                  },
                },
                [
                  !_vm.permanent
                    ? _c(
                        "v-btn",
                        {
                          staticClass:
                            "ma-3 soli-close white--text soli-text-shadow",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.reset()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("clear")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "white--text ml-4 font-bold soli-text-shadow",
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.title) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.subtitle
                    ? _c(
                        "v-card-subtitle",
                        { staticClass: "white--text" },
                        [
                          _c(
                            "v-list",
                            {
                              staticClass: "transparent",
                              attrs: { dense: "" },
                            },
                            _vm._l(_vm.subtitle, function (item) {
                              return _c(
                                "v-list-item",
                                { key: item.text, staticClass: "theme--dark" },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "white--text mr-2" },
                                    [_vm._v(_vm._s(item.icon))]
                                  ),
                                  _vm._v(_vm._s(item.text)),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "screenCapture",
              staticClass: "screen-capture",
              class: {
                white: _vm.screenCapture,
              },
            },
            [
              _vm._t("header"),
              _vm._v(" "),
              !_vm.lessonDetails && !_vm.imgSrc && !_vm.relative
                ? _c(
                    "div",
                    {
                      class: [
                        "pl-3",
                        _vm.cardBody
                          ? "card-body-min soli-blue pb-2"
                          : "transparent",
                        _vm.lowTitle ? "flex align-end" : null,
                        _vm.relative ? "half-round" : null,
                      ],
                    },
                    [
                      !_vm.screenCapture && !_vm.permanent
                        ? _c(
                            "v-btn",
                            {
                              class: [
                                "ma-3 soli-close",
                                _vm.cardBody
                                  ? "white--text soli-text-shadow"
                                  : "white",
                              ],
                              staticStyle: { "z-index": "999 !important" },
                              attrs: { icon: "" },
                              on: { click: _vm.reset },
                            },
                            [_c("v-icon", [_vm._v("clear")])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-card-title",
                        {
                          class: [
                            "font-bold animate__animated",
                            _vm.cardBody
                              ? "white--text soli-text-shadow"
                              : "soli-grey",
                            _vm.titleAnimation,
                          ],
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.title) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.textSubtitle
                        ? _c(
                            "v-card-subtitle",
                            {
                              class: [
                                "pl-4",
                                _vm.cardBody ? "soli-grey-text" : "soli-grey",
                                _vm.limitSubtitle
                                  ? "limit-subtitle pb-0 mb-4"
                                  : "pb-3",
                              ],
                            },
                            [_vm._v(_vm._s(_vm.textSubtitle))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$slots.subtitle
                        ? _c(
                            "v-card-subtitle",
                            { class: { "pb-0": !!_vm.$slots.tabs } },
                            [_vm._t("subtitle")],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("tabs"),
                      _vm._v(" "),
                      _vm.selectionText.length
                        ? _c(
                            "v-card-subtitle",
                            {
                              class: [
                                "px-4 pb-0",
                                _vm.cardBody ? "white--text" : null,
                              ],
                            },
                            [
                              _c(
                                "v-chip-group",
                                { attrs: { column: "" } },
                                _vm._l(_vm.selectionText, function (text, idx) {
                                  return _c(
                                    "div",
                                    {
                                      key: text.name,
                                      staticClass: "animate__animated",
                                      class: _vm.textAnimation,
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "findText",
                                            text.name
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            `${text.selection.data()}${
                                              idx ==
                                              _vm.selectionText.length - 1
                                                ? ""
                                                : "\u00A0·\u00A0"
                                            }`
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectionChips.length
                        ? _c(
                            "v-card-subtitle",
                            {
                              class: [
                                "pl-3 py-0",
                                _vm.cardBody ? "white--text" : null,
                              ],
                            },
                            [
                              _c(
                                "v-chip-group",
                                { attrs: { column: "" } },
                                _vm._l(_vm.selectionChips, function (chip) {
                                  return _c(
                                    "v-chip",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !chip.selection.hide,
                                          expression: "!chip.selection.hide",
                                        },
                                      ],
                                      key: chip.name,
                                      staticClass:
                                        "soli-grey mr-1 animate__animated",
                                      class: _vm.chipAnimation ?? null,
                                      attrs: {
                                        outlined: "",
                                        small: "",
                                        color: "white",
                                        ripple: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("findChip", chip)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(chip.selection.data()))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  class: [
                    _vm.cardBody ? "soli-blue" : null,
                    _vm.relative ? "soli-round" : null,
                  ],
                  attrs: { disabled: _vm.disabled },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitForm.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "main-container",
                      class: [
                        _vm.limitScroll
                          ? "limit-scroll"
                          : _vm.limitScroll != null
                          ? "shrink-limit-scroll"
                          : null,
                        _vm.mobileScroll ? "mobile-scroll" : null,
                        _vm.cardBody ? "card-body" : null,
                        _vm.noContainer ? "pa-0" : null,
                        !_vm.showCancelBtn && !_vm.hideBtn && !_vm.isSignature
                          ? "py-0"
                          : null,
                      ],
                    },
                    [
                      _c(
                        "div",
                        { class: _vm.subtitle ? "" : "px-3" },
                        [
                          _vm._t("body"),
                          _vm._v(" "),
                          _vm.error
                            ? _c(
                                "p",
                                { staticClass: "caption red--text px-3" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.error.form) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          !_vm.hideButtonContainer
            ? _c(
                "v-container",
                {
                  class: [
                    _vm.extraBtn ? "pb-5" : null,
                    _vm.showCancelBtn ? "py-5 px-5" : "py-0",
                    _vm.fixedBtn ? "py-5" : "py-0",
                    _vm.hideBtn ? "py-0" : "py-5 px-5",
                    _vm.mobileScroll || _vm.relative ? "pt-0" : null,
                    _vm.fullscreen ? "mobile-fixed-btn" : null,
                  ],
                  staticStyle: { background: "white" },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "padding-bottom":
                          "env(safe-area-inset-bottom) !important",
                      },
                    },
                    [
                      _vm._t("extraBtn", null, { block: "" }),
                      _vm._v(" "),
                      !_vm.hideBtn && !_vm.choices
                        ? _c("SoliBtn", {
                            attrs: {
                              gradient: _vm.gradient,
                              type: "submit",
                              text: _vm.text,
                              icon: _vm.icon,
                              block: "",
                              disabled: !_vm.saveChanges,
                              loading: _vm.isLoading,
                            },
                            on: { click: _vm.submitForm },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.choices
                        ? _c(
                            "div",
                            { staticClass: "flex flex-col gap-4" },
                            [
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex justify-end" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "soli-round",
                                      attrs: { color: "error", text: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.reset()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Nevermind\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "soli-round",
                                      attrs: {
                                        loading: _vm.loading,
                                        color: "primary",
                                        disabled: !_vm.saveChanges,
                                        text: "",
                                      },
                                      on: { click: _vm.submitForm },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Continue\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("cancelBtn", null, { block: "" }),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("footer", null, { fixed: "", block: "", large: "" }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }